import React, { useState } from 'react'
import { Checkbox, Drawer, Dropdown, Menu } from 'antd'

import { usePet, useToggle, notifOps } from '../../modules'
import Select from 'react-select'

const NewScheme = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [policyNo, setPolicyNo] = useState()
    const [schemeType, setSchemeType] = useState()
    const [operatedBy, setOperatedBy] = useState()
    const [company, setCompany] = useState()
    const [markupPercentage, setMarkupPercentage] = useState(0)
    const [capitationAmount, setCapitationAmount] = useState(0)
    const [rebateAmount, setRebateAmount] = useState(0)
    const [insurances, setInsurances] = useState([])
    const [companies, setCompanies] = useState([])

    const close = () => {
        toggle()
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'policyNo':
                setPolicyNo(e.target.value)
                break

            case 'markupPercentage':
                setMarkupPercentage(e.target.value)
                break

            case 'capitationAmount':
                setCapitationAmount(e.target.value)
                break

            case 'rebateAmount':
                setRebateAmount(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Scheme has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    const [{ loading }, execute] = usePet('newScheme', {
        name, 
        policyNo, 
        schemeType: schemeType?.value, 
        operatedBy: operatedBy?.value, 
        company: company?.value, 
        markupPercentage, 
        capitationAmount, 
        rebateAmount
    }, { notify: true, callback: onComplete, manual: true })

    const types = ['Capitation', 'Copay', 'Fee for Service', 'Full', 'NHIF Rebate']

    usePet('insuranceCompanies', { limit: 100 }, { notify: true, callback: async ({ data }) => { 
        setInsurances(data?.insurances?.map(ins => ({
            label: ins.name,
            value: ins._id
        })))
    } })

    usePet('companies', { limit: 100 }, { notify: true, callback: async ({ data }) => { 
        setCompanies(data?.companies?.map(comp => ({
            label: comp.name,
            value: comp._id
        })))
    } })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Scheme</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">New Scheme</p>
            <div className="divide-y divide-light-gray-400">
                <div>
                    <div>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Scheme Name
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-name" 
                                    type="text" 
                                    value={ name }
                                    name="name"
                                    placeholder="Hisani Insurance" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Policy No.
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-policyNo" 
                                    type="text" 
                                    value={ policyNo }
                                    name="policyNo"
                                    placeholder="XXXXXXXXX" />
                            </div>
                        </div>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-gender">
                                    Scheme Type
                                </label>
                                <Select
                                    value={schemeType}
                                    onChange={setSchemeType}
                                    options={types.map(item => ({ label: item, value: item }))}
                                    placeholder="Select Scheme Type" />
                            </div>
                            <div className="w-full md:w-3/5 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-gender">
                                    Operated By
                                </label>
                                <Select
                                    value={ operatedBy }
                                    onChange={setOperatedBy}
                                    options={ insurances }
                                    placeholder="Select Insurance Company" />
                            </div>
                        </div>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-gender">
                                    Company <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                                </label>
                                <Select
                                    value={ company }
                                    onChange={setCompany}
                                    options={ companies }
                                    placeholder="Select Company" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Scheme Markup Percentage
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-markupPercentage" 
                                    type="number" 
                                    value={ markupPercentage }
                                    name="markupPercentage"
                                    placeholder="0" />
                            </div>
                        </div>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Capitation Amount
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-capitationAmount" 
                                    type="number" 
                                    value={ capitationAmount }
                                    name="capitationAmount"
                                    placeholder="0" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Rebate Amount
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-rebateAmount" 
                                    type="number" 
                                    value={ rebateAmount }
                                    name="rebateAmount"
                                    placeholder="0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default NewScheme